export default {
  loading: '…',
  lang: {
    en: 'English',
    de: 'Deutsch',
    ru: 'Русский',
    fr: 'Français'
  },
  nav: {
    tools: 'Tools',
    connect: 'Connect',
    discord: 'Discord',
    signIn: 'Mit Steam anmelden',
    signOut: 'Abmelden'
  },
  app: {
    runTime: 'Laufzeit {time}',
    titleBreeder: 'rosi.wtf | Breeder',
    titleProgress: '{pct}% | GEN.{gen}'
  },
  logo: {
    plantTooltip:
      'Wähle eine Pflanzenart, um den Überblick über dein Kreuzungsprojekt zu behalten. Die Auswahl <strong>beeinflusst nicht</strong> das Rechenergebnis.'
  },
  sim: {
    eyebrow: 'rosi.wtf | Breeder',
    title: 'Kreuzungsplaner',
    lead:
      'Pro Pflanze eine sechsbuchstabige Genzeile einfügen. Wenn der Browser es erlaubt, Spielfenster erfassen und Gene per OCR lesen. Keine Installation nötig.',
    calculate: 'Berechnen',
    stop: 'Stopp',
    skip: 'Überspringen',
    skipTooltip: 'Früh zur nächsten Generation springen (schneller, kann Pfade verpassen).',
    emptyTitle: 'Keine brauchbaren Kreuzungen aus dieser Genliste',
    emptyBody:
      'Mehr Pflanzen hinzufügen oder Werte in den Einstellungen anpassen. Stärkere Ausgangs-Gene liefern meist bessere Pfade.',
    browserGen2:
      'Der gewählte Setzling stammt aus der <strong>2.</strong> Generation. Kreuze zuerst die benötigten Setzlinge. Klicke auf <span class="simulator_highlight-guide">markierte</span> Setzlinge, um zu sehen, wie du sie kreuzt.',
    browserGen3:
      'Der gewählte Setzling stammt aus der <strong>3.</strong> Generation. Kreuze zuerst die benötigten Setzlinge. Klicke auf <span class="simulator_highlight-guide">markierte</span> Setzlinge, um zu sehen, wie du sie kreuzt.',
    browserGeoBefore: 'Platziere Pflanzen mit „E“ neben dem ',
    browserGeoAfter:
      '-Symbol in den östlichsten Feldern der Pflanzkiste und Pflanzen mit „W“ in den westlichsten Feldern, um die Kreuzung zu beeinflussen.'
  },
  gene: {
    current: 'Aktuell',
    saved: 'Gespeichert',
    copied: 'Kopiert!',
    copyShare: 'Link kopieren',
    save: 'Speichern',
    geneSequences: 'Gensequenzen',
    geneHint: 'Eine Pflanze pro Zeile: sechs Buchstaben G, H, Y, W oder X.'
  },
  results: {
    labelG: 'Anzahl G',
    labelY: 'Anzahl Y',
    labelH: 'Anzahl H',
    geneN: 'Gen {n}',
    ariaIncG: 'G-Anzahl erhöhen',
    ariaDecG: 'G-Anzahl verringern',
    ariaIncY: 'Y-Anzahl erhöhen',
    ariaDecY: 'Y-Anzahl verringern',
    ariaIncH: 'H-Anzahl erhöhen',
    ariaDecH: 'H-Anzahl verringern',
    conflict: 'Deine Filter widersprechen sich: {detail}',
    alreadyOwned: 'Diesen Klon hast du schon an Position #{n} in deiner Liste',
    noResults: 'Mit diesen Filtern gibt es keine Treffer!',
    clickCard: 'Klicke eine Karte für Details zu Generationen und Kreuzung!',
    pressHold: 'Halte eine Karte gedrückt, um Varianten zu sehen.',
    showing: '{shown} von {total} Treffern. Filter enger stellen, wenn es zu viel ist.',
    ruleMinZero: 'Minimum ist null..',
    ruleMaxSix: 'Nicht mehr als sechs...',
    ruleWhole: 'Muss eine ganze Zahl sein...'
  },
  map: {
    highlightedTitle: 'Hervorgehobenes Ergebnis',
    clearHighlight: 'Hervorhebung löschen',
    tipGeoBefore: 'Platziere Pflanzen mit „E“ neben dem ',
    tipGeoAfter:
      '-Symbol in den östlichsten Feldern der Pflanzkiste und Pflanzen mit „W“ in den westlichsten Feldern, um die Kreuzung zu beeinflussen.',
    learnMore: 'mehr erfahren',
    tipGen2:
      'Der gewählte Setzling stammt aus der <strong>2.</strong> Generation. Kreuze zuerst die benötigten Setzlinge. Klicke auf <span class="highlighted-map_highlight-guide">markierte</span> Setzlinge, um zu sehen, wie du sie kreuzt.',
    tipGen3:
      'Der gewählte Setzling stammt aus der <strong>3.</strong> Generation. Kreuze zuerst die benötigten Setzlinge. Klicke auf <span class="highlighted-map_highlight-guide">markierte</span> Setzlinge, um zu sehen, wie du sie kreuzt.',
    numberHelp: '<strong>#NUMBER</strong> ist die Position des Setzlings in deiner Genliste.'
  },
  browser: {
    helperVariants: 'Hier siehst du verschiedene Wege, denselben Setzling zu kreuzen.',
    optionBest: 'Beste Option',
    optionAlt: 'Alternative Option {n}'
  },
  previous: {
    empty: 'Du hast keine gespeicherten Gen-Sets.',
    genesCount: 'Gene: {n}'
  },
  about: {
    trigger: 'Über',
    title: 'Über',
    fork:
      '<strong>rosi.wtf | Breeder</strong> ist ein Fork der älteren <strong>rustbreeder.com</strong>-Web-App, neu gestaltet für <a href="https://rosi.wtf" target="_blank" rel="noopener noreferrer">rosi.wtf</a>. Genetik-Logik und Ablauf stammen größtenteils von dort (<a href="https://github.com/wojciechSlodziak/rust-breeder" target="_blank" rel="noopener noreferrer">Quellcode auf GitHub</a>).',
    fromOriginal: 'Vom Originalautor:',
    hi: 'Hi, ich hoffe, die App gefällt dir :).',
    because: 'Ich habe sie gebaut, weil Kreuzen jeden Wipe ohne Tool ziemlich mühsam war.',
    feedback:
      'Feedback oder Hilfe? Schreib mir auf meinem <a href="https://discord.gg/Va5475pqFw" target="_blank" rel="noopener noreferrer">Discord-Server</a>.',
    donate:
      'Wenn du die Arbeit unterstützen und die Kosten mittragen willst, kannst du <a href="https://donorbox.org/rust-crossbreeding-optimizer?default_interval=o" target="_blank" rel="noopener noreferrer">spenden</a>.',
    fine: 'Rust Breeder steht in keiner Verbindung zu Facepunch.',
    close: 'Schließen'
  },
  options: {
    title: 'Einstellungen',
    reset: 'Zurücksetzen',
    tabCross: 'Kreuzung',
    tabUi: 'UI & Ton',
    performance: 'Leistung',
    workers: 'Anzahl Worker',
    workersHint: '~65 % der Kerne balanciert Tempo und Temperatur. Höher für Tempo, niedriger für weniger Last.',
    breeding: 'Zucht',
    saplingsRange: 'Setzlingsbereich',
    saplingsRangeHint: '2–5 ist ein guter Kompromiss aus Nutzen und Geschwindigkeit.',
    generations: 'Generationen',
    saplingsNextGen: 'Setzlinge für nächste Generation',
    saplingsNextGenHint: 'Die besten Ergebnisse der aktuellen Gen fließen in die nächste Berechnung ein.',
    withRepetitions: 'Kombinationen mit Wiederholungen prüfen',
    withRepetitionsHint: 'Prüft auch Kombinationen, bei denen eine Pflanze mehrfach vorkommt. Etwas langsamer.',
    geneScores: 'Gen-Scores',
    advanced: 'Erweitert',
    manualMinScore: 'Mindest-Tracking-Score manuell',
    manualMinScoreHint: 'Niedrigere Werte nutzen mehr Speicher.',
    minimumTrackedScore: 'Mindest-Tracking-Score',
    general: 'Allgemein',
    soundsOn: 'Ton: An',
    soundsOff: 'Ton: Aus',
    autoSaveOn: 'Gene automatisch speichern: An',
    autoSaveOff: 'Gene automatisch speichern: Aus',
    autoSaveHint: 'Aus zeigt einen manuellen Speichern-Button für Gen-Sets.',
    scanner: 'Scanner',
    skipGuideYes: 'Scan-Anleitung überspringen: Ja',
    skipGuideNo: 'Scan-Anleitung überspringen: Nein',
    calibrationHeader: 'Bildschirm-Ausrichtung',
    calibrationLead: 'Anpassen, wenn die Buchstaben nicht zu Auflösung oder Rust-UI-Skalierung passen.',
    horizontalNudge: 'Horizontal verschieben',
    horizontalHint: 'Verschiebt die erfassten Streifen links/rechts.',
    verticalNudge: 'Vertikal verschieben',
    verticalHint: 'Verschiebt die Streifen hoch/runter.',
    geneBoxScale: 'Gen-Kasten-Skalierung',
    geneBoxHint: '1,0 = Standard.',
    resetAlignment: 'Ausrichtung zurücksetzen',
    close: 'Schließen',
    set: 'Anwenden',
    setTooltip: 'Nur für diese Sitzung.',
    save: 'Speichern',
    saveTooltip: 'Übernehmen und im Browser merken.',
    ariaInc: 'Erhöhen',
    ariaDec: 'Verringern',
    genTickOne: 'eins',
    genTickTwo: 'zwei',
    genTickThree: 'drei',
    geneScoreRule: 'Muss eine Zahl zwischen -1 und 1 sein.',
    saplingsAddedRule: 'Muss eine positive ganze Zahl sein.',
    minTrackedRule: 'Erlaubter Bereich: -6 bis 6.'
  },
  scan: {
    scanRust: 'Rust scannen',
    stopScanning: 'Scan stoppen',
    initializing: 'Initialisiere…',
    dialogTitle: 'Wie scanne ich Rust nach Setzlingen?',
    displayPreview: 'Vorschau anzeigen',
    close: 'Schließen',
    scan: 'Scannen',
    li1:
      'Am besten <strong>Chrome</strong>, <strong>Edge</strong> oder <strong>Firefox</strong> verwenden. Andere Browser können Probleme machen.',
    li2:
      'Stelle sicher, dass <strong>USER INTERFACE SCALE</strong> in Rust auf <strong>1,0</strong> steht. Manchmal zeigt der Schieberegler 1,0, der Wert ist aber z. B. 0,97. Mit <strong>graphics.uiscale</strong> in der Rust-Konsole den echten Wert prüfen.',
    li3:
      'Spiel im <strong>16:9</strong>-Format (1600×900, 1920×1080, 2560×1440 oder 4K) und <strong>randlos</strong>. Bei anderer Monitorauflösung: <strong>Fenstermodus</strong> und 16:9 wählen.',
    li4: '<strong>SCAN</strong> klicken und das Rust-Fenster auswählen.',
    li5a: 'Nach Start des Scans musst du die Gene auf dem Bildschirm zeigen:',
    li5b1: 'Setzling im Inventar oder Lager anklicken,',
    li5b2: 'oder einen gepflanzten Setzling ansehen.',
    li5c: 'Pro Setzling braucht die Erfassung etwa eine Sekunde.',
    li6:
      'Viel Spaß! Wenn es nicht klappt, melde dich auf Discord. Mit aktiver <strong>Vorschau</strong> siehst du, was schiefgeht.'
  },
  mapCard: {
    score: 'Score:',
    chance: 'Chance:',
    centerLabel: 'Zentraler Setzling:',
    centerAnyExtra: 'beliebige zusätzliche Pflanze gleichen Typs',
    tooltipCenter1:
      'Setzling, der in der Kreuzungsphase Gene von den umgebenden Setzlingen übernimmt. In die Mitte pflanzen und allein wachsen lassen, bis etwa 50 % in der <strong>Setzling</strong>-Phase erreicht sind. Danach die umgebenden Setzlinge drumherum pflanzen.',
    tooltipCenter2:
      'Es ist immer eine <strong>zusätzliche</strong> Pflanze: Zeigt die App <strong>fünf</strong> umgebende Setzlinge, musst du <strong>sechs</strong> Pflanzen insgesamt setzen.',
    tooltipCenter3Exact:
      'Du musst exakt die Pflanze pflanzen, die die App vorgibt, sonst funktioniert die Kreuzung nicht wie erwartet.',
    tooltipCenter4Genes:
      'Die Gene der Pflanze sind egal. Mehr G hilft, schneller fertig zu werden, weil sie schneller wächst.',
    tooltipCenter5SameType:
      '„Gleicher Typ“ heißt: Kreuzt du gelbe Beeren, muss der zentrale Samen/Klon eine <strong>gelbe Beere</strong> sein; bei Kartoffeln <strong>muss</strong> es ein Kartoffel-Samen/Klon sein.',
    surroundingLabel: 'Umgebende Setzlinge:',
    tooltipSurrounding1:
      'Setzlinge, die um den zentralen Setzling stehen, bevor die <strong>Kreuzung</strong> beginnt. Alle müssen vom gleichen Typ sein.',
    tooltipSurrounding2East: 'Platziere die umgebenden Setzlinge gemäß OST/WEST-Hinweisen um den zentralen Setzling.',
    tooltipSurrounding2NoEast: 'Steht der zentrale Setzling mittig, ist die Platzierung der umgebenden Setzlinge egal.',
    tooltipSurrounding3:
      'Der zentrale Setzling reicht in Kreuzung horizontal, vertikal und diagonal. Du kannst alle acht freien Felder der Pflanzkiste nutzen.'
  }
};
